class Authentication {
    constructor(authLink) {
        this.authLink = authLink;
        this.buttonAction();
    }
    activate(){
        //set timeout to wait for the page to load

        const self = this;
        const authUrl = this.authLink; // Change this to your auth page
        const windowName = "Authenticate";
        const windowSize = "width=600,height=700";
        const authWindow = window.open(authUrl, windowName, windowSize);
        // Show page loading
        KTApp.showPageLoading(true);
        // Check if the pop-up was blocked
        if (popupBlockerChecker.check(authWindow)) {
            // Pop-up was blocked, redirecting in the same window
            window.location.href = authUrl;
        } else {
            authWindow.focus();
            // Setup an interval to check if the pop-up is closed
            const checkAuthWindow = setInterval(function() {
                if(popupBlockerChecker.check(authWindow)){
                    window.location.href = authUrl;
                }
                else if (authWindow.closed) {
                    clearInterval(checkAuthWindow);
                    KTApp.hidePageLoading();
                }
                }, 100);
        }


        window.addEventListener('message', event => {
            if (event.data === 'authSuccess') {
                //ajax call to check the session
                $.ajax({
                    url: '/dashboard?do=checkUserAuthentication',
                    type: 'GET',
                    dataType: '',
                    data: { organizationID: self.findGetParameter('organizationID')}
                }).done(function () {
                    window.location.reload();
                });
                document.getElementById('overlay').style.display = 'none'; // Hide the overlay on success
            }
        });
        // Event listener for the main page
        document.addEventListener('click', function() {
            if (authWindow && !authWindow.closed) {
                authWindow.focus(); // This will focus the pop-up window if it's not closed
            }
        });
    }
    buttonAction(){
        const self = this;
        $(document).on('click', '.two-fa-access', function(){
           self.activate();
        });
    }
    findGetParameter(parameterName) {
        var result = null,
            tmp = [];
        location.search
            .substr(1)
            .split("&")
            .forEach(function (item) {
                tmp = item.split("=");
                if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
            });
        return result;
    }
}

var popupBlockerChecker = {
    check: function(popup_window){
        var _scope = this;
        if (popup_window) {
            if(/chrome/.test(navigator.userAgent.toLowerCase())){
                setTimeout(function () {
                    return _scope._is_popup_blocked(_scope, popup_window);
                },200);
            }else{
                popup_window.onload = function () {
                    return _scope._is_popup_blocked(_scope, popup_window);
                };
            }
        }else{
            return _scope._displayError();
        }
        return false;
    },
    _is_popup_blocked: function(scope, popup_window){
        if ((popup_window.innerHeight > 0)==false){ return scope._displayError(); }
        return false;
    },
    _displayError: function(){
        return true;
    }
};
window.Authentication = Authentication;